import styles from "./table-empty-state.module.css";

type TableEmptyStateProps = {
	emptyState: React.ReactNode;
	hasActiveFilters: boolean;
	showEmptyState: boolean;
};

export function TableEmptyState({
	emptyState,
	hasActiveFilters,
	showEmptyState,
}: TableEmptyStateProps) {
	if (!showEmptyState) {
		return null;
	}

	if (hasActiveFilters) {
		return (
			<div className={styles.wrapper}>
				<div className={styles.emptyState}>
					<div className={styles.content}>
						<h2 className="title-2">No results found</h2>
						<p className="body-1">
							Try adjusting your filters to find what you&apos;re looking for.
						</p>
					</div>
				</div>
			</div>
		);
	}

	return <div className={styles.wrapper}>{emptyState}</div>;
}
